import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../../emotion-theme";

export const FileUpload = styled.div`
  & > div {
    margin: auto;
  }
`;

export const UploadSection = styled.div`
  padding: 100px;
  border: dashed 4px ${BASE_COLORS.lightGrey};
  margin-top: 150px;
`;

export const AssetListSection = styled.div`
  margin-bottom: 5px;
`;
